import styled from "styled-components";

export const PolicyCard = styled.article`
  border: 1px solid ${({ theme }) => theme.app.border};
  border-radius: 18px;
  background: ${({ theme }) => theme.app.bg.white};
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 28px;

  ${({ theme }) => theme.medias.max600} {
    padding: 20px;
  }

  h2 {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  h3 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 6px;
  }

  ul {
    margin-left: 16px;
    list-style: disc;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  p {
    line-height: 1.6;
    color: ${({ theme }) => theme.app.text.light1};
  }

  strong {
    display: block;
    margin: 8px 0 4px;
  }

  a {
    color: ${({ theme }) => theme.app.palette.blue[350]};
  }
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Subsection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
`;
